define((require) => {
    "use strict";

    var Backbone        = require("backbone"),
        PrototypeAction = require("ui/experience/action/PrototypeAction"),
        RestApi         = require("shared/services/RestApi");

    /**
     * Collection of PrototypeActions.
     */
    var PrototypeActionCollection = Backbone.Collection.extend("PrototypeActionCollection", {

        companyId: null,

        model: PrototypeAction,

        constructor: function(models, options) {
            this.__super();

            if (options) {
                this.companyId = options.companyId;
            }
        },

        comparator: function(prototypeAction) {
            // Not including the edit date when sorting, since this would make the actions move to
            // the top of list when they are edited.
            return -prototypeAction.get("createdAt");
        },

        /**
         * Returns the action prototypes where the embedded action have the specified type.
         *
         * @param {String} type - The type of the action, e.g. CustomJsAction.TYPE.
         * @return {PrototypeActionCollection}
         */
        filterByType: function(type) {
            var matchingPrototypeActions = this.filter((prototypeAction) => {
                return prototypeAction.get("action").get("type") === type;
            });

            // This is potentially dangerous because we're reusing the models in multiple
            // collections. So if you experience weird behaviour, try cloning the matching
            // prototypes.
            return new PrototypeActionCollection(matchingPrototypeActions);
        },

        /**
         * Returns the REST API URL for the company's actions, i.e.
         * "/api/companies/{companyId}/actions".
         *
         * @returns {String}
         */
        url: function() {
            // I does not make sense to call fetch on a filtered collection. We use the presense of
            // companyId to detect that.
            if (!this.companyId) {
                return null;
            }

            return RestApi.pathToCollectionOnResource(
                RestApi.Collections.COMPANIES,
                this.companyId, RestApi.Collections.ACTIONS
            );
        }
    });

    return PrototypeActionCollection;
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/PrototypeActionCollection.js